// import { ErrorType } from "@/types";

class HttpError<T = unknown> extends Error {
  status?: number;
  // TODO: Handle correct types
  // errorType?: ErrorType;
  errorType?: string;
  body?: T;

  constructor(args: {
    status?: number;
    message: string;
    // errorType?: ErrorType;
    errorType?: string;
    body?: T;
  }) {
    super(args.message);
    this.status = args.status;
    this.errorType = args.errorType;
    this.body = args.body;
  }
}

export default HttpError;
